
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g0MkC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $24ca3a40577d3379$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $24ca3a40577d3379$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Pagina zonder naam',
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Maak een nieuwe pagina aan en voeg deze in als link',
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Confluence-pagina aanmaken',
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Openen in Confluence',
    'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Je pagina is aangemaakt',
    'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Pagina aangemaakt',
    'editorExtensionLinkCreate.confluencePage.title': 'Nieuwe pagina aanmaken',
    'editorExtensionLinkCreate.genericError.description': 'Vernieuw de pagina en probeer het opnieuw.',
    'editorExtensionLinkCreate.genericError.title': 'Er is iets misgegaan',
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': 'Maak inline een issue aan en voeg de issue in als link',
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Jira-issue aanmaken',
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Openen in Jira',
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Je issue is aangemaakt',
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Issue aangemaakt',
    'editorExtensionLinkCreate.jiraIssue.title': 'Nieuw issue aanmaken',
    'editorExtensionLinkCreate.keyword.create': 'aanmaken',
    'editorExtensionLinkCreate.keyword.issue': 'issue',
    'editorExtensionLinkCreate.keyword.new': 'nieuw',
    'editorExtensionLinkCreate.keyword.page': 'pagina',
    'editorExtensionLinkCreate.keyword.publish': 'publiceren',
    'editorExtensionLinkCreate.keyword.raise': 'indienen',
    'editorExtensionLinkCreate.keyword.space': 'space',
    'editorExtensionLinkCreate.keyword.ticket': 'ticket'
};

});


//# sourceMappingURL=nl.0c55df4e.js.map
